import React, { Component } from 'react';
import { Tabs, Tab, ButtonToolbar, Button, Col } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import Toggle from 'react-toggle'
import { LanesCommand } from '../commands/LanesCommand';
import { LanesDraftCommand } from '../commands/LanesDraftCommand';
import { ImportLanesCommand } from '../commands/ImportLanesCommand';
import { SearchBar } from '../../SearchBar';
import { TitleRow } from '../../TitleRow';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { ProviderLanesActiveList } from './ProviderLanesActiveList';
import { ProviderLanesDraftList } from './ProviderLanesDraftList';
import { ImportProviderLaneForm } from './ImportProviderLaneForm';
import { ProviderLaneActiveForm } from './ProviderLaneActiveForm';
import { ProviderLaneDraftForm } from './ProviderLaneDraftForm';
import { LoadingSpinner } from '../../LoadingSpinner';
import { EditionSelector } from '../../EditionSelector';
import { PaginationHelper } from '../../helpers/PaginationHelper';

export class ProviderLanes extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {
                active: {
                    lanes: [],
                },
                draft: {
                    lanes: [],
                }
            },
            form: {
                active: {
                    lane: undefined,
                },
                draft: {
                    lane: undefined,
                },
                import: {
                    file: undefined,
                }
            },
            pagination: {
                active: {
                    page: 1,
                    elementsPerPage: 50
                },
                draft: {
                    page: 1,
                    elementsPerPage: 50
                }
            },
            actions: {
                active: {
                    isLoading: true,
                    isUpdating: false,
                    isDeleting: false,
                },
                draft: {
                    isLoading: true,
                    isUpdating: false,
                    isDeleting: false,
                },
                isLoadingEditions: false,
            },
            commands: {
                active: {
                    lanes: new LanesCommand(),
                },
                draft: {
                    lanes: new LanesDraftCommand(),
                },
                import: {
                    lanes: new ImportLanesCommand(),
                }
            },
            render: {
                tab: "active",
                compare: false,
                filter: ""
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            },
        };
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
        this.context.addEditionObserver(this);
        this.updateNetworkEdition();
        this.updateDraftNetworkEdition();
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ---------------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = false;

        this.setState({
            actions: actions
        });
    }

    updateNetworkEdition() {
        const { actions } = this.state;

        actions.active.isLoadingLanes = true;

        this.setState({
            actions: actions
        }, () => {
            this.getLanes("active");
        });
    }

    updateDraftNetworkEdition() {
        const { actions } = this.state;

        actions.draft.isLoadingLanes = true;

        this.setState({
            actions: actions
        }, () => {
            this.getLanes("draft");
        });
    }

    listCallback(type, func) {
        const { callbacks } = this.state;

        callbacks.list[type] = func;

        this.setState({
            callbacks: callbacks
        });
    }

    listSuccessCallback(result, dataType, updateData, updateAction, callback) {
        const { data, pagination, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, pagination[dataType].elementsPerPage);

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = result;
        if (0 !== totalPages) {
            pagination.page = pagination.page > totalPages ? totalPages : pagination.page;
        }
        else {
            pagination.page = 1;
        }

        // Update data
        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
        }, () => {
            if ("function" === typeof (callback)) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, updateData, updateAction) {
        const { data, pagination, actions, message } = this.state;

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = [];
        pagination[dataType].page = 1;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(result, updateAction, dataType, callback) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            result.message = `${message.message}\n${result.message}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: result.message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if ("function" === typeof (callback)) {
            callback(result.data);
        }

        this.updateNetworkEdition();
        this.updateDraftNetworkEdition();
    }

    operationErrorCallback(messageReceived, updateAction, dataType) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ----------------------

    getLanes(dataType) {
        const { actions, commands } = this.state;

        actions[dataType].isLoading = true;

        this.setState({
            actions: actions
        });

        commands[dataType].lanes.getByProvider(
            (a) => this.listSuccessCallback(a, dataType, "lanes", "isLoading"),
            (a) => this.listErrorCallback(a, dataType, "lanes", "isLoading"),
        );
    }

    // ---------------------------
    onToggleIsComparing() {
        const { render } = this.state;

        render.compare = !render.compare;

        this.setState({
            render: render
        });
    }

    onSearch(filter) {
        const { render } = this.state;

        render.filter = filter;

        this.setState({
            render: render
        });
    }

    onSelectTab(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onCreateClick(dataType) {
        const { form } = this.state;

        form[dataType].lane = {
            title: "Criar",
            type: "create",
            original: undefined,
            obj: {
                id: 0,
                name: "",
                type: [],
                segments: [],
                newSegments: [],
            },
            nameInputError: null,
            editionInputError: null,
        };

        this.setState({
            form: form
        });
    }

    onImportClick() {
        const { form } = this.state;

        form.import = {
            file: null,
            title: "Importar",
            dataType: 7,
            lane: {
                type: "import",
                original: undefined,
                obj: {
                    id: 0,
                    name: "",
                    segments: [],
                    newSegments: [],
                },
                editionInputError: null,
            },
            fileError: null,
        };

        this.setState({
            form: form
        });
    }

    onChangePage(page, dataType) {
        const { pagination } = this.state;

        pagination[dataType].page = page;

        this.setState({
            pagination: pagination
        });
    }

    onChangeElementsPerPage(elementsPerPage, dataType) {
        const { pagination } = this.state;

        pagination[dataType].elementsPerPage = elementsPerPage;

        this.setState({
            pagination: pagination
        });
    }

    onChangeValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].lane.obj[value] = e.target.value;

        this.setState({
            form: form,
        });
    }

    onSelectValue(e, value, dataType) {

        const { form } = this.state;

        form[dataType].lane.obj[value] = e;

        this.setState({
            form: form,
        });
    }

    onAddSegmentValue(e, dataType) {
        const { form } = this.state;

        if (!Array.isArray(form[dataType].lane.obj.newSegments)) {
            form[dataType].lane.obj.newSegments = [];
        }

        const newSegments = form[dataType].lane.obj.newSegments.slice();
        const oldSegments = form[dataType].lane.obj.segments.slice();

        var segment = {
            id: e.layer._leaflet_id,
            breakpoints: []
        };

        for (var i in e.layer._latlngs) {
            var breakpoint = {
                latitude: e.layer._latlngs[i].lat,
                longitude: e.layer._latlngs[i].lng
            }
            segment.breakpoints.push(breakpoint);
        }
        newSegments.push(segment);

        form[dataType].lane.obj.newSegments = [];
        form[dataType].lane.obj.segments = [];

        this.setState({
            form: form
        }, () => this.onEditFormSegments(newSegments, oldSegments, dataType));
    }

    onEditFormSegments(newSegments, oldSegments, dataType) {
        const { form } = this.state;

        form[dataType].lane.obj.newSegments = newSegments;
        form[dataType].lane.obj.segments = oldSegments;

        this.setState({
            form: form
        });
    }

    onEditSegmentsValue(e, dataType) {
        const { form } = this.state;

        let newSegments = form[dataType].lane.obj.newSegments.slice();
        const oldSegments = [];// since leaflet id's aren't consistent and also cannot be set, for segments loaded from
        //the database, so the old segments list needs to be erased and rewritten everytime a segment
        //is edited or deleted, assuring no data is lost or duplicated

        // this verification needs to be done separatelly since all segments, when deleted, can only be accessed through e.layers._layers
        // this can't be done to old segments since we can't identify them by their ids, so their list is entirely rewritten, through e.target._layers
        //whereas when it comes to newly drawn segments we have access to their correct temporary ids, and have to use them to update their separate list
        // newly drawn segments have a separate list because otherwise they would also be rendered by leaflet, duplicating them
        // both lists are merged on lane save
        if (e.type === "draw:deleted") { // if method type is delete
            for (const i in e.layers._layers) {
                const newSegment = newSegments.find(o => o.id === e.layers._layers[i]._leaflet_id);
                if (undefined !== newSegment) { // if it's a new segment, delete it from the newSegment list
                    newSegments = newSegments.filter(seg => seg.id !== e.layers._layers[i]._leaflet_id);
                }
            }
        }
        let newSegment = undefined;
        for (const i in e.target._layers) { // go through all the other layers to check if an old segment has been deleted or if any segment has been edited

            if (undefined === e.target._layers[i]._latlngs) { //check for correct type of layer (segment)
                continue;
            }

            const segment = this.buildSegment(e, i);

            newSegment = newSegments.find(o => o.id === segment.id);
            if (undefined !== newSegment) { // check if it's a new segment
                newSegment.breakpoints = segment.breakpoints; // if it's a new segment, change it's breakpoints
            } else { // if it's an old segment
                oldSegments.push(segment); // add new data, since all the contents of the segments list have been erased at the start of the method
            }
        }

        form[dataType].lane.obj.newSegments = [];
        form[dataType].lane.obj.segments = [];

        this.setState({
            form: form
        }, () => 
            this.onEditFormSegments(newSegments, oldSegments, dataType)
        );
    }

    buildSegment(e, i) {
        const segment = {
            id: 0,
            breakpoints: []
        };

        const editedSegmentMapId = e.target._layers[i]._leaflet_id;

        for (const j in e.target._layers[i]._latlngs) {
            const breakpoint = {
                latitude: e.target._layers[i]._latlngs[j].lat,
                longitude: e.target._layers[i]._latlngs[j].lng
            }
            segment.id = editedSegmentMapId;
            segment.breakpoints.push(breakpoint);
        }
        return segment;
    }

    onEditLaneClick(lane, dataType) {
        const { form, render } = this.state;

        if (render.compare) {
            const { data } = this.state;

            lane = data[dataType].lanes.find(unmutedLane => unmutedLane.id === lane.id);
        }

        form[dataType].lane = {
            title: "Editar",
            type: "edit",
            original: lane,
            obj: Object.assign({
                id: 0,
                name: "",
                type: "",
                segments: [],
                newSegments: []
            }, lane),
            nameInputError: null,
        };

        form[dataType].lane.obj.segments = form[dataType].lane.obj.segments.slice();

        this.setState({
            form: form
        });
    }

    onDeleteClick(lane, dataType) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar a micro mobilidade? "${lane.name}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    operation: "delete",
                    id: lane.id,
                    dataType: dataType
                }
            }
        });
    }

    onImportLaneFormExit() {
        const { form } = this.state;

        form.import.file = undefined;
        form.import.lane = undefined;

        this.setState({
            form: form
        });
    }

    onLaneFormExit(dataType) {
        const { form } = this.state;

        form[dataType].lane = undefined;

        this.setState({
            form: form
        });
    }

    onImportLane() {
        if (this.isValidInput("import")) {
            const { form, commands, actions } = this.state;

            actions.draft.isUpdating = true;

            const callback = () => this.getLanes("draft");
            commands.import.lanes.uploadFileByProvider(
                form.import,
                (a) => this.operationSuccessCallback(a, "isUpdating", "draft", callback),
                (a) => this.operationErrorCallback(a, "isUpdating", "draft")
            );

            this.setState({
                actions: actions
            });

            this.onImportLaneFormExit();
        }
    }

    onSaveLane(dataType) {
        const { form, commands, actions } = this.state;

        form[dataType].lane.obj.segments = form[dataType].lane.obj.segments.concat(form[dataType].lane.obj.newSegments);
        actions[dataType].isUpdating = true;

        commands[dataType].lanes.saveByProvider(
            form[dataType].lane.obj,
            (a) => this.operationSuccessCallback(a, "isUpdating", dataType, () => this.getLanes(dataType)),
            (a) => this.operationErrorCallback(a, "isUpdating", dataType)
        );

        this.setState({
            actions: actions
        });

        this.onLaneFormExit(dataType);
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { commands } = this.state;

            switch (argument.operation) {
                case "delete":
                    actions[argument.dataType].isDeleting = true;
                    commands[argument.dataType].lanes.deleteByProvider(
                        argument.id,
                        (a) => this.operationSuccessCallback(a, "isDeleting", argument.dataType, () => this.getLanes(argument.dataType)),
                        (a) => this.operationErrorCallback(a, "isDeleting", argument.dataType)
                    );
                    break;

                default: // DO NOTHING
                    break;
            }
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ----------------------

    isValidInput(dataType) {
        const { form } = this.state;
        let errors = 0;

        if (("import" !== dataType) && (undefined === form[dataType].lane.obj.name || null === form[dataType].lane.obj.name || "" === form[dataType].lane.obj.name)) {
            form[dataType].lane.nameInputError = 'error';
            errors++;
        }

        if (("draft" === dataType || ("import" === dataType)) && (undefined === form[dataType].lane.obj.countyEdition || null === form[dataType].lane.obj.countyEdition || "" === form[dataType].lane.obj.countyEdition)) {
            form[dataType].lane.editionInputError = 'error';
            errors++;
        }

        if (("import" === dataType) && (undefined === form[dataType].file || null === form[dataType].file || "" === form[dataType].file)) {
            form[dataType].fileError = 'error';
            errors++;
        }

        this.setState({
            form: form
        });

        return 0 === errors;
    }

    // ---------------------------

    renderImportLaneForm() {
        const { form } = this.state;

        if (undefined === form.import.file) {
            return null;
        }

        return (
            <ImportProviderLaneForm show={true}
                form={form.import}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "import")}
                onImport={() => this.onImportLane()}
                onHide={() => this.onImportLaneFormExit()} />
        );
    }

    renderActiveForm() {
        const { form } = this.state;

        if (undefined === form.active.lane) {
            return null;
        }

        return (
            <ProviderLaneActiveForm show={true}
                form={form.active.lane}
                isEditingMap={form.active.isEditingMap}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "active")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "active")}
                onAddSegmentValue={(a) => this.onAddSegmentValue(a, "active")}
                onEditSegmentsValue={(a) => this.onEditSegmentsValue(a, "active")}
                onDeleteSegmentsValue={(a) => this.onEditSegmentsValue(a, "active")}
                onSave={() => this.onSaveLane("active")}
                onHide={() => this.onLaneFormExit("active")} />
        );
    }

    renderDraftForm() {
        const { form } = this.state;

        if (undefined === form.draft.lane) {
            return null;
        }

        return (
            <ProviderLaneDraftForm show={true}
                form={form.draft.lane}
                isEditingMap={form.draft.isEditingMap}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "draft")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "draft")}
                onAddSegmentValue={(a) => this.onAddSegmentValue(a, "draft")}
                onEditSegmentsValue={(a) => this.onEditSegmentsValue(a, "draft")}
                onDeleteSegmentsValue={(a) => this.onEditSegmentsValue(a, "draft")}
                onSave={() => this.onSaveLane("draft")}
                onHide={() => this.onLaneFormExit("draft")} />
        );
    }

    renderLanesActive() {
        const { data, actions, render, pagination } = this.state;

        return (
            <ProviderLanesActiveList lanes={data.active.lanes}
                draftLanes={data.draft.lanes}
                currentPage={pagination.active.page}
                elementsPerPage={pagination.active.elementsPerPage}
                isLoading={actions.active.isDeleting || actions.active.isUpdating || actions.active.isLoading || (render.compare && actions.draft.isLoading)}
                filter={render.filter}
                isComparing={render.compare}
                onChangePage={(a) => this.onChangePage(a, "active")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "active")}
                onEditClick={(a) => this.onEditLaneClick(a, "active")}
                onDeleteClick={(a) => this.onDeleteClick(a, "active")} />
        );
    }

    renderLanesDraft() {
        const { data, actions, render, pagination } = this.state;

        return (
            <ProviderLanesDraftList 
                lanes={data.draft.lanes}
                currentPage={pagination.draft.page}
                elementsPerPage={pagination.draft.elementsPerPage}
                isLoading={actions.draft.isUpdating || actions.draft.isDeleting || actions.draft.isLoading || (render.compare && actions.draft.isLoading)}
                filter={render.filter}
                isComparing={render.compare}
                onChangePage={(a) => this.onChangePage(a, "draft")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "draft")}
                onEditClick={(a) => this.onEditLaneClick(a, "draft")}
                onDeleteClick={(a) => this.onDeleteClick(a, "draft")} />
        );
    }

    renderTabOptions(selectedTab) {
        if ("active" === selectedTab) {
            const { render } = this.state;

            return (
                <div className="tab-options">
                    <label>
                        <Toggle className="comparison-toggle"
                            checked={render.compare}
                            icons={false}
                            onChange={() => this.onToggleIsComparing()} />
                        <span>COMPARAR</span>
                    </label>
                </div>
            );
        }

        return null;
    }

    renderTabs() {
        const { selectedTab, render } = this.state;

        return (
            <div className="tab-with-options">
                <Tabs id="datamanager_tabs" activeKey={selectedTab} onSelect={(a) => this.onSelectTab(a)}>
                    <Tab eventKey="active" key="active" title="Ativo">
                        {this.renderLanesActive()}
                    </Tab>
                    <Tab eventKey="draft" key="draft" title="Rascunho">
                        {this.renderLanesDraft()}
                    </Tab>
                </Tabs>
                {this.renderTabOptions(render.tab)}
            </div>
        );
    }

    renderButtons(selectedTab) {
        if ("active" === selectedTab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    <Button onClick={() => this.onCreateClick("active")}>CRIAR</Button>
                </ButtonToolbar>
            );
        }

        if ("draft" === selectedTab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    <Button onClick={() => this.onCreateClick("draft")}>CRIAR</Button>
                    <Button onClick={() => this.onImportClick()}>IMPORTAR</Button>
                </ButtonToolbar>
            );
        }

        return null;
    }

    renderOperationFeedback(text, isExecuting) {
        return (
            <HandleMessage
                title={text}
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isExecuting}
                small
                noButtons />
        );
    }

    handleSaveLane(newLane) {
        const { data, pagination } = this.state;

        const updatedLanes = [...data.draft.lanes, newLane];

        this.setState({
            data: {
                ...data,
                draft: {
                    ...data.draft,
                    lanes: updatedLanes
                }
            },
            pagination: {
                ...pagination,
                draft: {
                    ...pagination.draft,
                    page: Math.ceil(updatedLanes.length / pagination.draft.elementsPerPage)
                }
            }
        });
    };

    render() {
        const { actions, render, message, dialog } = this.state;

        return (
            <div>
                <EditionSelector />

                <TitleRow title="Micro Mobilidade" showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        {this.renderButtons(render.tab)}
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                <div className="margin-top-15">
                    {this.renderTabs()}
                </div>

                {this.renderImportLaneForm()}
                {this.renderActiveForm()}
                {this.renderDraftForm()}

                {
                    this.renderOperationFeedback(
                        "A Executar...",
                        actions.active.isUpdating || actions.active.isDeleting ||
                        actions.draft.isUpdating || actions.draft.isDeleting
                    )
                }
                {this.renderOperationFeedback("A Carregar Edição...", actions.isLoadingEditions)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}
